import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Nav, Collapse, Button } from 'react-bootstrap';
import { authApi } from '../services/api';
import '../styles/AdminSidebar.css';

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isViewer = localStorage.getItem('admin_role') === 'viewer';
  const [newsOpen, setNewsOpen] = useState(true);
  const [categoriesOpen, setCategoriesOpen] = useState(true);
  const [projectsOpen, setProjectsOpen] = useState(true);
  const [quotationsOpen, setQuotationsOpen] = useState(true);

  const isActive = (path: string) => location.pathname === path;
  const isParentActive = (paths: string[]) => paths.some(path => location.pathname.startsWith(path));

  const handleLogout = async () => {
    await authApi.logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        <h4>Gerenciador</h4>
      </div>

      <Nav className="flex-column sidebar-nav">
        {/* Viewer: só Social Media */}
        {isViewer ? (
          <div className="nav-section">
            <Nav.Link
              as={Link}
              to="/admin/social"
              className={`nav-section-header ${isActive('/admin/social') ? 'active' : ''}`}
            >
              <i className="bi bi-bar-chart-line me-2"></i>
              Social Media
            </Nav.Link>
          </div>
        ) : (<>

        {/* Notícias */}
        <div className="nav-section">
          <div
            className={`nav-section-header ${isParentActive(['/admin/noticias']) ? 'active' : ''}`}
            onClick={() => setNewsOpen(!newsOpen)}
          >
            <i className="bi bi-newspaper me-2"></i>
            Notícias
            <i className={`bi bi-chevron-${newsOpen ? 'down' : 'right'} ms-auto`}></i>
          </div>
          <Collapse in={newsOpen}>
            <div>
              <Nav.Link
                as={Link}
                to="/admin/noticias/criar"
                className={`nav-section-item ${isActive('/admin/noticias/criar') ? 'active' : ''}`}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Criar
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin"
                className={`nav-section-item ${isActive('/admin') ? 'active' : ''}`}
              >
                <i className="bi bi-list-ul me-2"></i>
                Listar
              </Nav.Link>
            </div>
          </Collapse>
        </div>

        {/* Categorias */}
        <div className="nav-section">
          <div
            className={`nav-section-header ${isParentActive(['/admin/categorias']) ? 'active' : ''}`}
            onClick={() => setCategoriesOpen(!categoriesOpen)}
          >
            <i className="bi bi-tags me-2"></i>
            Categorias de Notícias
            <i className={`bi bi-chevron-${categoriesOpen ? 'down' : 'right'} ms-auto`}></i>
          </div>
          <Collapse in={categoriesOpen}>
            <div>
              <Nav.Link
                as={Link}
                to="/admin/categorias/criar"
                className={`nav-section-item ${isActive('/admin/categorias/criar') ? 'active' : ''}`}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Criar
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/categorias"
                className={`nav-section-item ${isActive('/admin/categorias') ? 'active' : ''}`}
              >
                <i className="bi bi-list-ul me-2"></i>
                Listar
              </Nav.Link>
            </div>
          </Collapse>
        </div>

        {/* Projetos */}
        <div className="nav-section">
          <div
            className={`nav-section-header ${isParentActive(['/admin/projetos']) ? 'active' : ''}`}
            onClick={() => setProjectsOpen(!projectsOpen)}
          >
            <i className="bi bi-folder me-2"></i>
            Projetos
            <i className={`bi bi-chevron-${projectsOpen ? 'down' : 'right'} ms-auto`}></i>
          </div>
          <Collapse in={projectsOpen}>
            <div>
              <Nav.Link
                as={Link}
                to="/admin/projetos/criar"
                className={`nav-section-item ${isActive('/admin/projetos/criar') ? 'active' : ''}`}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Criar
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/projetos"
                className={`nav-section-item ${isActive('/admin/projetos') ? 'active' : ''}`}
              >
                <i className="bi bi-list-ul me-2"></i>
                Listar
              </Nav.Link>
            </div>
          </Collapse>
        </div>

        {/* Cotações */}
        <div className="nav-section">
          <div
            className={`nav-section-header ${isParentActive(['/admin/quotations']) ? 'active' : ''}`}
            onClick={() => setQuotationsOpen(!quotationsOpen)}
          >
            <i className="bi bi-currency-dollar me-2"></i>
            Cotações
            <i className={`bi bi-chevron-${quotationsOpen ? 'down' : 'right'} ms-auto`}></i>
          </div>
          <Collapse in={quotationsOpen}>
            <div>
              <Nav.Link
                as={Link}
                to="/admin/quotations/new"
                className={`nav-section-item ${isActive('/admin/quotations/new') ? 'active' : ''}`}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Criar
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/quotations"
                className={`nav-section-item ${isActive('/admin/quotations') ? 'active' : ''}`}
              >
                <i className="bi bi-list-ul me-2"></i>
                Listar
              </Nav.Link>
            </div>
          </Collapse>
        </div>

        {/* Social Media */}
        <div className="nav-section">
          <Nav.Link
            as={Link}
            to="/admin/social"
            className={`nav-section-header ${isActive('/admin/social') ? 'active' : ''}`}
            style={{ cursor: 'pointer' }}
          >
            <i className="bi bi-bar-chart-line me-2"></i>
            Social Media
          </Nav.Link>
        </div>

        </>)}
      </Nav>

      <div className="sidebar-footer">
        <Button variant="outline-danger" onClick={handleLogout} className="w-100">
          <i className="bi bi-box-arrow-right me-2"></i>
          Sair
        </Button>
      </div>
    </div>
  );
};

export default AdminSidebar;
